import { Button } from '@/components/ui/button';
import { useRegistrationStore } from '@/lib/store/registrationStore';
import { cn } from '@/lib/utils';
import { Check } from 'lucide-react';
import { usePageTranslation } from '@/i18n/useTranslation';
import { authTranslations } from '@/i18n/locales/en/auth';
import { authTranslations as thAuthTranslations } from '@/i18n/locales/th/auth';

interface StepCrmCurrentToolProps {
  onNext: () => void;
}

const TOOL_OPTIONS = [
  { id: 'excel', icon: '📊', labelKey: 'crmToolExcel' as const },
  { id: 'line_notes', icon: '📝', labelKey: 'crmToolLineNotes' as const },
  { id: 'crm_app', icon: '💼', labelKey: 'crmToolCrmApp' as const },
  { id: 'nothing', icon: '🤷', labelKey: 'crmToolNothing' as const },
];

export function StepCrmCurrentTool({ onNext }: StepCrmCurrentToolProps) {
  const { qualificationData, updateQualificationData } = useRegistrationStore();
  const t = usePageTranslation({ en: authTranslations, th: thAuthTranslations });

  const selected = qualificationData.crmCurrentTool || null;

  const handleSelect = (id: string) => {
    updateQualificationData({ crmCurrentTool: selected === id ? null : id });
  };

  return (
    <div className="flex flex-col">
      <div className="mb-4">
        <h2 className="text-xl font-semibold text-foreground md:text-center">
          {t.crmCurrentToolTitle}
        </h2>
      </div>

      <div className="space-y-2.5 mb-4">
        {TOOL_OPTIONS.map((opt) => {
          const isSelected = selected === opt.id;
          return (
            <button
              key={opt.id}
              type="button"
              onClick={() => handleSelect(opt.id)}
              className={cn(
                'w-full flex items-center justify-between px-4 py-3 rounded-md border transition-colors',
                isSelected
                  ? 'border-primary bg-primary/10'
                  : 'border-border hover:bg-muted'
              )}
            >
              <div className="flex items-center gap-3">
                <span className="text-lg">{opt.icon}</span>
                <span className="font-medium text-sm text-foreground">{t[opt.labelKey]}</span>
              </div>
              {isSelected && <Check className="w-5 h-5 text-primary" />}
            </button>
          );
        })}
      </div>

      <div className="sticky bottom-0 pt-2 pb-[max(0.5rem,env(safe-area-inset-bottom))] bg-gradient-to-t from-background via-background to-transparent">
        <Button onClick={onNext} className="w-full h-12 rounded-md text-base" disabled={!selected}>
          {t.next}
        </Button>
      </div>
    </div>
  );
}
